module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/flatlays/flatlay-03-1c819a15c86fea6fe3b7f2406d6f201f.webp";